import { createAction } from 'redux-actions';
import { setCookie } from '../../../utils/dom-utils';
import { getQueryStringValue } from '../../../utils/utils';

const CUSTOMER_WEB_VIEW = 'CUSTOMER_WEB_VIEW';
export const GET_API_KEY = 'GET_API_KEY';
export const LOCATION_CHANGE = 'LOCATION_CHANGE';
export const SET_IS_MOBILE_PARAM = 'SET_IS_MOBILE_PARAM';

const isSandbox = window.location.host.includes('localhost');
const isInternalDomain = window.location.host.includes('awstrp');
const inIFrame = window.self !== window.top && (isSandbox || isInternalDomain);
const isSalesforce =
  window.location.pathname.includes('salesforce') &&
  (isSandbox || isInternalDomain);

export default function authentication(
  state = {
    authenticated: false,
    customerWebViewEnabled: false,
    isIFrame: inIFrame,
    isSalesforceRep: isSalesforce,
    delegatedUser: undefined,
    entitlements: [],
    validSession: false,
    userId: undefined,
    isLoaded: false,
    isLoading: false,
    hasFailed: false,
    apikey: '',
    salesForceDepartment: '',
    isMobileParam: false, //mobile params flag
  },
  { payload, type }
) {
  switch (type) {
    case `SET_${CUSTOMER_WEB_VIEW}`: {
      return {
        ...state,
        isIFrame: payload.isIFrame,
        isSalesforceRep: payload.isSalesforceRep,
        customerWebViewEnabled:
          payload.isInternalDomain && !payload.isSalesforceRep,
      };
    }

    case `SET_SALESFORCE_CODE`: {
      return {
        ...state,
        salesForceDepartment: payload,
      };
    }

    case `${GET_API_KEY}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };

    case `${GET_API_KEY}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        apiKey: payload.apiKey,
      };

    case `${GET_API_KEY}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasFailed: true,
        error: payload,
      };
    case SET_IS_MOBILE_PARAM: {
      return {
        ...state,
        isMobileParam: payload,
      };
    }
    default:
      return state;
  }
}

export const setCustomerWebViewContext = (context) => {
  const type = `SET_${CUSTOMER_WEB_VIEW}`;
  return (dispatch) =>
    dispatch({
      type,
      payload: context,
    });
};

export const setSalesforceDepartmentCode = (code) => {
  const type = `SET_SALESFORCE_CODE`;
  return (dispatch) =>
    dispatch({
      type,
      payload: code,
    });
};

export const getAPIKey = () => {
  const basePath = document.location.origin;
  const baseURL = `${basePath}/usis/transactions`;
  const isLocalhost =
    window &&
    window.location.hostname.toLowerCase().indexOf('localhost') !== -1;
  const apiUrl = isLocalhost
    ? `${baseURL}/api-conf.json`
    : `${baseURL}/api-config-v1.json`;
  return (dispatch) => {
    const action = createAction(GET_API_KEY)(
      fetch(apiUrl).then((res) => res.json())
    );
    return dispatch(action);
  };
};

export const locationChange = () => {
  return (dispatch) => {
    const action = createAction(`${LOCATION_CHANGE}`)(true);
    return dispatch(action);
  };
};

const isMobileCookieSet = () => {
  const temp = document.cookie
    .split('; ')
    .find((row) => row.startsWith('additionalParams='));
  return (
    temp?.replace(
      new RegExp(
        '^(?:.*[&\\?]' +
          encodeURIComponent('mobile').replace(/\s+/g, '\\$&') +
          '(?:\\=([^&]*))?)?' +
          '.*$',
        'i'
      ),
      '$1'
    ) === '1'
  );
};

export const setAdditionalParams = () => {
  return (dispatch) => {
    if (getQueryStringValue('mobile') === '1' && !isMobileCookieSet()) {
      setCookie('additionalParams', window.location.search, 36500);
      const action = createAction(`${SET_IS_MOBILE_PARAM}`)(true);
      return dispatch(action);
    } else if (getQueryStringValue('mobile') === '1' || isMobileCookieSet()) {
      const action = createAction(`${SET_IS_MOBILE_PARAM}`)(true);
      return dispatch(action);
    } else {
      const action = createAction(`${SET_IS_MOBILE_PARAM}`)(false);
      return dispatch(action);
    }
  };
};
